import React from 'react'
import styled from 'styled-components'
import Button from "./Button"
import { observer } from 'mobx-react'
import { store } from '../lib/utils'

const Outer = styled.div`
  margin-top: 1.5rem;
  text-align: center;
`

export default observer(({analyticsLabel}) => (
  !store.vimeoIds &&
  <Outer>
    <Button onClick={() => window.ga && window.ga('send', 'event', 'cta', 'click', analyticsLabel)}
            type="anchor" href="https://gum.co/frontendcenter" target="_blank">
      Subscribe Now for $15/month
    </Button>
  </Outer>
))



/** WEBPACK FOOTER **
 ** ./src/components/Cta.js
 **/